export class BookingScroll {
    constructor() {
        let hash = window.location.hash.replace('_','');
        if (hash
            && document.querySelector(hash)
            && document.body.offsetWidth < 768)
        {
            this.scroll(hash);
        }
    }

    scroll(element) {
        $([document.documentElement, document.body]).animate({
            scrollTop: $(element).offset().top,
        },);
    }
}